import { compile } from 'handlebars'
import template from './hbs/tcpa-form.hbs'

const builder = fetch(template)
  .then(res => res.text())
  .then(compile);

export default async function render({ question, cfid, trustedform, trustedform_cfid, leadid, leadid_cfid, consentTextActive, consentText, manualSubmit = false, saveConsentText = false, autoScrollToConsent = false }) {
  question = question || ''
  cfid = cfid || ''
  trustedform_cfid = trustedform_cfid || ''
  leadid_cfid = leadid_cfid || ''

  trustedform = !!trustedform
  leadid = !!leadid

  const required = !!manualSubmit
  const required_class = manualSubmit ? 'tcpa-required' : ''

  return (await builder)({
    question, cfid,
    trustedform_cfid,
    leadid_cfid,
    required,
    required_class,
    manualSubmit,
    consentTextActive,
    consentText,
    trustedform,
    leadid,
    saveConsentText,
    autoScrollToConsent,
  }).trim()
};
